import { ReactNode } from 'react';
import {
    ALERT_PLANS,
    API_PAYMENT_PERIOD,
    APP_FOR_PAYMENT,
    HT_PAYMENT_PROVIDER,
    HYPERTRACKER_API_PLANS,
    HypertrackerPrice,
    PAYMENT_METHOD,
} from '@/state/payments/paymentsTypes';

export interface PurchaseForm {
    duration: API_PAYMENT_PERIOD;
    paymentMethod: PAYMENT_METHOD | HT_PAYMENT_PROVIDER;
    couponCode: string;
    plan: HYPERTRACKER_API_PLANS | ALERT_PLANS;
    termsAccepted: boolean;
    selectedApp: APP_FOR_PAYMENT;
}

export enum MODE {
    INITIAL = 'initial',
    SUCCESS = 'success',
    ERROR = 'error',
}

export enum UPGRADE_TYPE {
    TO_ENTERPRISE = 'to-enterprise',
    API = 'api',
}

export type PricesData = Record<string, HypertrackerPrice> & {
    plansList: ALERT_PLANS[];
};

export interface PlansType {
    description?: string;
    secondTitle?: string;
    name: string;
    plan: HYPERTRACKER_API_PLANS | ALERT_PLANS;
    monthPrice: string;
    requestCount?: string;
    rateLimit?: string;
    webhooks?: string;
    websockets?: string;
    requestsIcon?: ReactNode;
    rateLimitIcon?: ReactNode;
    webhooksIcon?: ReactNode;
    websocketsIcon?: ReactNode;
}

export interface PriceCardDetails {
    plan: ALERT_PLANS;
    name: string;
    price: number;
    order: number;
    checkMarks: { label: string; description?: string; labelFontStyle?: string }[];
    buttonLabel: string;
    basedSteps?: string[];
    billed?: string;
    monthPrice?: string;
}

export interface PeriodOption {
    value: API_PAYMENT_PERIOD;
    label: string;
    badgeKey?: string;
}
